import React, { Component, JSX } from 'react'
import { Typography } from "@iconics/components";

export default class IbssHomeCard extends Component<IProps>
{
    private handleClick(): void
    {
        const { href, onClick } = this.props;
        if (!href)
        {
            return;
        }
        onClick(href);
    }

    private handlePress(e: React.KeyboardEvent<HTMLDivElement>): void
    {
        if (e.key === 'Enter' || e.key === ' ') 
        {
            e.preventDefault();
            this.handleClick();
        }
    }

    public render(): JSX.Element 
    {
        const { imageSource, imageAlt, title, description, href } = this.props;
        return (
            <div
                role="button"
                tabIndex={0}
                style={{ cursor: (href ? 'pointer' : 'default') }}
                onClick={() => this.handleClick()}
                onKeyDown={(e) => this.handlePress(e)}
            >
                <div style={{
                    minHeight: 130,
                    display: 'flex',
                    boxShadow: 'var(--shadows-sd-system-elevation-shadow-level1)',
                }}>
                    <div
                        style={{
                            width: '130px',
                            minWidth: '130px',
                            overflow: 'hidden'
                        }}
                    >
                        {
                            imageSource &&
                            <img
                                src={imageSource}
                                alt={imageAlt}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                    display: 'block',
                                }}
                            />
                        }
                    </div>
                    <div style={{ margin: 'var(--spacing-sd-system-dimension-spacing-none) var(--spacing-sd-system-dimension-spacing-none) var(--spacing-sd-system-dimension-spacing-medium) var(--spacing-sd-system-dimension-spacing-medium)' }}>
                        <Typography variant="h3" role="title" size="medium">{title}</Typography>
                        <Typography variant="div" role="body" size="small">{description}</Typography>
                    </div>
                </div>
            </div >
        )
    }
}

interface IProps
{
    imageSource: string;
    imageAlt: string;
    title: string;
    description: string;
    href: string;
    onClick: (href: string) => void;
}